export default "__VITE_ASSET__lriBRi3D__"